import { useEffect, useRef, useState } from "react";

const Counter = ({ value, suffix = "", duration = 1400 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const step = (now) => {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setCount(Math.round(eased * value));
              if (p < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [value, duration]);

  return (
    <span ref={ref} className="font-mono">
      {count}
      {suffix}
    </span>
  );
};

export const StatsRow = ({ items }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden">
    {items.map((s, i) => (
      <div
        key={i}
        data-testid={`stat-item-${i}`}
        className="bg-[#0a0a0a] p-5 sm:p-8"
      >
        <div className="text-3xl sm:text-5xl font-display font-bold text-white">
          <Counter value={s.value} suffix={s.suffix} />
        </div>
        <div className="mt-2 text-[10px] sm:text-sm text-neutral-400 uppercase tracking-[0.2em] font-mono">
          {s.label}
        </div>
      </div>
    ))}
  </div>
);

export default StatsRow;
